var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_154715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 8.18176V12.0545H15.3817C15.1454 13.2999 14.4362 14.3545 13.3726 15.0636L16.618 17.5818C18.5089 15.8364 19.5998 13.2728 19.5998 10.2273C19.5998 9.51824 19.5362 8.83636 19.418 8.18187L9.99988 8.18176Z",
    fill: "url(#paint0_linear_1128_154715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39555 11.9033L3.66358 12.4636L1.07263 14.4818C2.71808 17.7454 6.09056 20 9.99962 20C12.6996 20 14.9632 19.1091 16.6177 17.5818L13.3723 15.0636C12.4814 15.6636 11.345 16.0273 9.99962 16.0273C7.39963 16.0273 5.19061 14.2728 4.39964 11.9091L4.39555 11.9033Z",
    fill: "url(#paint1_linear_1128_154715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07265 5.51819C0.390868 6.86359 0 8.38179 0 9.99994C0 11.6181 0.390868 13.1363 1.07265 14.4817C1.07265 14.4907 4.39998 11.8999 4.39998 11.8999C4.19998 11.2999 4.08177 10.6636 4.08177 9.99984C4.08177 9.33612 4.19998 8.69979 4.39998 8.0998L1.07265 5.51819Z",
    fill: "url(#paint2_linear_1128_154715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 3.98182C11.4726 3.98182 12.7816 4.49089 13.8271 5.47272L16.6907 2.60912C14.9543 0.990971 12.6999 0 9.99982 0C6.09076 0 2.71808 2.24545 1.07263 5.51819L4.39986 8.10001C5.19072 5.73635 7.39984 3.98182 9.99982 3.98182Z",
    fill: "url(#paint3_linear_1128_154715)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_154715",
    x1: 9.99988,
    y1: 12.8818,
    x2: 19.5998,
    y2: 12.8818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_154715",
    x1: 1.07263,
    y1: 15.9516,
    x2: 16.6177,
    y2: 15.9516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_154715",
    x1: 0,
    y1: 9.99996,
    x2: 4.39998,
    y2: 9.99996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1128_154715",
    x1: 1.07263,
    y1: 4.05,
    x2: 16.6907,
    y2: 4.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_154715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogleIcon);
export default __webpack_public_path__ + "static/media/SocialGoogleIcon.ba7055d736587635011fa18037a2b146.svg";
export { ForwardRef as ReactComponent };